import { IApiConfigChecker, classMetadataKey } from './common';
import { getMetadata, defineMetadata } from 'reflect-metadata/no-conflict';

export function ApiConfig(config: IApiConfigChecker) {
  return function (target: object, key: string | symbol = classMetadataKey) {
    const metadata: IApiConfigChecker[] = getMetadata(
      'api-config',
      target,
      key,
    );

    const nextMetadata = metadata ? [...metadata, config] : [config];

    defineMetadata('api-config', nextMetadata, target, key);
  };
}
